import { render } from "./PromptCardsList.vue?vue&type=template&id=6bff67b2&scoped=true"
import script from "./PromptCardsList.vue?vue&type=script&lang=js"
export * from "./PromptCardsList.vue?vue&type=script&lang=js"

import "./PromptCardsList.vue?vue&type=style&index=0&id=6bff67b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bff67b2"]])

export default __exports__